import React from "react";
import MyBet from "../../casinoComponents/myBet";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { formatOdds, formatAmount } from "../../../utils/formatOdds";
import { latestBets } from "../../../utils/casinoMyBets";

/** Top 9 payouts shown by the reference RightSideBar (from its casino/rules API) for Muflis Teenpatti. */
const TOP9_RULES = [
  ["Card 9", "1 TO 3"],
  ["Card 8", "1 TO 4"],
  ["Card 7", "1 TO 5"],
  ["Card 6", "1 TO 8"],
  ["Card 5", "1 TO 30"],
];

// Reference markup: .card.m-b-10 > .card-header > h6.card-title.d-inline-block "Rules"
//   + .card-body(padding 10px) > table.table.table-bordered.rules-table
export function TeenMufRulesCard() {
  return (
    <div className="card m-b-10">
      <div className="card-header">
        <h6 className="card-title d-inline-block">{"\n          Rules\n          "}</h6>
      </div>{" "}
      <div className="card-body" style={{ padding: "10px" }}>
        <table className="table table-bordered rules-table">
          <tbody>
            <tr className="text-center">
              <th colSpan={2}>Top 9</th>
            </tr>
            {TOP9_RULES.map(([nat, val]) => (
              <tr key={nat}>
                <td width="60%">{nat}</td>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function formatBetDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// Reference vcasino RightSideBar My Bets card (UserName / Rate / Amount)
function VMyBets({ bets = [], onViewMore }) {
  const list = latestBets(bets); // latest 10, like the reference
  return (
    <div className="card m-b-10 my-bet" id={IS_REF_MOBILE ? "casino-bets" : undefined}>
      <div className="card-header">
        <h6 className="card-title float-left">My Bets</h6>{" "}
        <a
          href="javascript:void(0)"
          className="btn btn-back float-right"
          onClick={(e) => {
            e.preventDefault();
            if (typeof onViewMore === "function") onViewMore();
          }}
        >
          View More
        </a>
      </div>{" "}
      <div className="card-body1">
        <div className="tab-content">
          <div id="matched-bet" className="tab-pane active">
            <div className="table-responsive1">
              <table className="table coupon-table table-striped mb-0">
                <thead>
                  <tr>
                    <th style={{ minWidth: "90px" }}>UserName</th>
                    <th className="text-right" style={{ minWidth: "50px" }}>Rate</th>
                    <th className="text-right" style={{ minWidth: "70px" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center">No records found</td>
                    </tr>
                  ) : (
                    list.map((bet, i) => {
                      const t = String(bet.type || bet.gametype || "").toLowerCase();
                      const border = t === "lay" ? "lay-border" : t === "back" ? "back-border" : undefined;
                      return (
                        <React.Fragment key={bet.id || i}>
                          <tr className={border}>
                            <td colSpan={4}>
                              <b>{bet.selection || bet.matchedBet || "-"}</b>{" "}
                              <span className="float-right">{formatBetDate(bet.placeDate)}</span>
                            </td>
                          </tr>
                          <tr className={border}>
                            <td>{bet.userName}</td>
                            <td className="text-right">{formatOdds(bet.odds)}</td>
                            <td className="text-right">{formatAmount(bet.stake)}</td>
                          </tr>
                          <tr>
                            <td colSpan={4} style={{ height: "3px", padding: 0 }} />
                          </tr>
                        </React.Fragment>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/** Right sidebar for Muflis Teenpatti: My Bets (casino or vcasino variant) + Top 9 Rules card. */
export default function TeenMufRightSide({ bets, onViewMore, virtual = false }) {
  return (
    <>
      {virtual ? <VMyBets bets={bets} onViewMore={onViewMore} /> : <MyBet bets={bets} onViewMore={onViewMore} />}{" "}
      <TeenMufRulesCard />
    </>
  );
}
